const ACTIVITY_LOG_MARKDOWN_LINK_PATTERN = /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g;
const URL_PATTERN =
  /(([a-z]+:\/\/)?(([a-z0-9-]+\.)+([a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(:[0-9]{1,5})?(\/[a-z0-9_\-.~]+)*(\/([a-z0-9_\-.]*)(\?[a-z0-9+_\-.%=&]*)?)?(#[a-zA-Z0-9!$&'()*+.=-_~:@/?]*)?)(?=[\s,).!?;:]|$)/gi;

export function escapeHtml(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function renderAnchorHtml(label: string, url: string) {
  const href = /^[a-z]+:\/\//i.test(url) ? url : `//${url}`;

  return `<a target="_blank" rel="noopener noreferrer" href="${escapeHtml(href)}">${escapeHtml(label)}</a>`;
}

function renderMarkdownFormattingHtml(text: string) {
  return escapeHtml(text)
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*(?=$|[\s).,!?:;])/gm, '$1<em>$2</em>')
    .replace(/(^|[\s(])_([^_\n]+)_(?=$|[\s).,!?:;])/gm, '$1<em>$2</em>');
}

function renderAutolinkHtml(text: string) {
  let html = '';
  let lastIndex = 0;

  for (const match of text.matchAll(URL_PATTERN)) {
    const matchIndex = match.index ?? 0;
    const [url] = match;
    const linkUrl = url.replace(/[).!?;:]+$/, '');
    const trailingPunctuation = url.slice(linkUrl.length);

    html += renderMarkdownFormattingHtml(text.slice(lastIndex, matchIndex));
    html += renderAnchorHtml(linkUrl, linkUrl);
    html += escapeHtml(trailingPunctuation);
    lastIndex = matchIndex + url.length;
  }

  html += renderMarkdownFormattingHtml(text.slice(lastIndex));
  return html;
}

export function renderActivityLogTextMarkdownHtml(text: string) {
  let html = '';
  let lastIndex = 0;

  for (const match of text.matchAll(ACTIVITY_LOG_MARKDOWN_LINK_PATTERN)) {
    const matchIndex = match.index ?? 0;
    const [fullMatch, label, url] = match;

    html += renderAutolinkHtml(text.slice(lastIndex, matchIndex));
    html += renderAnchorHtml(label, url);
    lastIndex = matchIndex + fullMatch.length;
  }

  html += renderAutolinkHtml(text.slice(lastIndex));
  return html;
}
